<template>
  <div class="mb-2">
    <div
      v-if="question?.show_subject !== false"
      class="flex items-start"
    >
      <p
        v-if="!question?.is_html_subject"
        class="text-dark-blue"
      >
        {{ subject }}
      </p>
      <div
        v-else
        class="text-sm"
        v-html="question?.subject"
      />
      <slot />
    </div>
    <p class="mb-4 text-xxs font-bold uppercase text-gray-over-dark">
      {{ question.description }}
    </p>
    <!-- <input
        class="p-4 bg-off-white rounded w-full text-sm focus:bg-white focus:text-dark-gray border-transparent border hover:border-placeholder-gray"
        @input="handleInput"
        :placeholder="(question.is_type === 'input_integer') ? '7' : '7.50'"
        v-model="answer"
        :onkeypress="(question.is_type === 'input_integer') ? isInteger : isFloat"
      /> -->
    <file-selector-grid-questions
      v-model="answer"
      :question_id="question_id"
      :subject="subject"
      :question="question"
      :set-onboarding-packet="setOnboardingPacket"
      :toggle-required="toggleRequired"
      :required="required"
      :conditional_children="conditional_children"
      :multiple="question?.is_type == 'file_multiple' ? true : false"
      accept="image/*,.pdf"
      @run-comparison="emitForComparison"
    />
  </div>
</template>

<script>
import FileSelectorGridQuestions from '@/components/FileSelectorGridQuestions.vue';
// import { jsonToFormData } from '@/common/json';

export default {
  name: 'File',
  components: {
    FileSelectorGridQuestions,
  },
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    currentTaxFormId: Number,
    onboardingPacketId: Number,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
  },
  emits: ['child-check'],
  data() {
    return {
      answer: [],
    };
  },
  computed: {
    mostRecentAnswerId() {
      return this.question?.most_recent_previous_answer?.id;
    },
  },
  watch: {
    mostRecentAnswerId: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal > oldVal) {
        // this.$store.dispatch('questions/attachFileUploadByAnswerId', { id: newVal, file: this.answer[0] });
      }
    },
  },
  created() {
    let recentAnswer = this.question?.most_recent_previous_answer;
    if (recentAnswer) {
      this.answer = this.question.is_type === 'file' ? recentAnswer?.files : [];
      // this.emitForComparison(this.answer);
    }
  },
  methods: {
    // handleInput(e) {
    //   // this.answer = e.target.files;
    //   // const formData = jsonToFormData(this.answer[0])
    //   // console.log('this.$refs');
    //   // console.dir(this.$refs[`file-input-question-${this.question_id}`]);
    //   console.log('target from File.vue');
    //   console.dir(e);
    //   console.dir(e.target);
    //   console.dir(e.target?.files);
    //   let files = [];
    //   this.answer.forEach(function(el) {
    //     files.push(el);
    //   });
    //   let body =
    //     {
    //       "company_question_id": this.question_id,
    //       "file_uploads_attributes": [
    //         {
    //           "file_name": this.answer?.[0]?.name,
    //           "file_attachment": [ this.answer?.[0] ]
    //           // "file": e.target?.files[0]
    //         }
    //       ]
    //     };
    //     // if (this.answer?.length > 0) {
    //       this.setOnboardingPacket(body);
    //     // }
    //     if (this.required) {
    //       (this.answer?.length > 0) ? this.toggleRequired(this.question_id, true) : this.toggleRequired(this.question_id, false)
    //     }
    //     // this.emitForComparison(e.target.value);
    // },
    // isInteger(e) {
    //   let charCode = (e.which) ? e.which : e.keyCode
    //   if (charCode > 31 && (charCode < 48 || charCode > 57))
    //       return false;
    //   return true;
    // },
    // isFloat(e) {
    //   let charCode = (e.which) ? e.which : e.keyCode
    //   if (charCode > 31 && (charCode != 46 &&(charCode < 48 || charCode > 57)))
    //       return false;
    //   return true;
    // },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (
            child?.evaluation_js?.length > 0 &&
            child?.company_question_id > 0
          ) {
            this.$emit(
              'child-check',
              child.company_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
    },
  },
};
</script>
